import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1feb1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap col-12 align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-title" }, [
  /*#__PURE__*/_createTextVNode(" Forgot your  "),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"white-space":"nowrap"},
    class: "d-flex align-items-center col"
  }, [
    /*#__PURE__*/_createTextVNode(" password? "),
    /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = { class: "mb-0 mt-2 h2" }
const _hoisted_5 = { class: "col-12 forgot-password-form py-3 py-lg-5" }
const _hoisted_6 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_7 = { class: "mb-3 row flex-wrap gy-2" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "blurb text-center text-sm-start" }, "A password reset email has been sent to your email address. Please click the link in the email to proceed with your password reset.", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "col-12"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-0 mt-2 h2" }, "Reset your password", -1))
const _hoisted_14 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_15 = { class: "mb-3 row flex-wrap gy-2" }
const _hoisted_16 = { class: "col-auto" }

import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { reactive, ref, onMounted, Ref } from "vue";
import { ValidateFieldsError } from "async-validator";
import { useAuthStore } from "@/stores/auth";
import { useRoute, useRouter } from "vue-router";
import { handleInvalidForm } from "@/utilities/api";

type RequestFormData = { emailAddress: string };
type ResetFormData = { emailAddress: string; passwordResetToken: string; newPassword: string; confirmPassword: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordForm',
  emits: ["done"],
  setup(__props, { emit: emits }) {

const authStore = useAuthStore();

const route = useRoute();
let code: Ref<string | null> = ref(null);
let done: Ref<boolean> = ref(false);
const router = useRouter();
const requestFormRef = ref<FormInstance>();
const resetFormRef = ref<FormInstance>();
let requestFormData = reactive<RequestFormData>({
  emailAddress: "",
});
let resetFormData = reactive<ResetFormData>({
  emailAddress: "",
  passwordResetToken: "",
  newPassword: "",
  confirmPassword: "",
});

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(.{8,})$/;

const validatePassword = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please enter a password"));
  } else if (!passwordRegex.test(value)) {
    callback(new Error("Minimum 8 characters: 1 uppercase, 1 lowercase, 1 symbol and 1 number"));
  } else {
    if (resetFormData.confirmPassword !== "") {
      if (!resetFormRef.value) return;
      resetFormRef.value.validateField("confirmPassword", () => null);
    }
    callback();
  }
};

const validatePassword2 = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please confirm the password"));
  } else if (value !== resetFormData.newPassword) {
    callback(new Error("The passwords do not match"));
  } else {
    callback();
  }
};

const requestRules = reactive<FormRules<RequestFormData>>({
  emailAddress: [{ required: true, type: "email", message: "Please enter a valid email address", trigger: "change" }],
});

const resetRules = reactive<FormRules<ResetFormData>>({
  emailAddress: [{ required: true, type: "email", message: "Please enter a valid email address", trigger: "change" }],
  newPassword: [{ required: true, validator: validatePassword, trigger: "change" }],
  confirmPassword: [{ required: true, validator: validatePassword2, trigger: "change" }],
});

onMounted(() => {
  if (route.query.code != null) {
    code.value = resetFormData.passwordResetToken = decodeURI(route.query.code as string);
  }

  if (route.query.email) {
    resetFormData.emailAddress = requestFormData.emailAddress = route.query.email as string;
  }
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      console.log("valid");
      if (!code.value) {
        authStore.forgotPassword(requestFormData.emailAddress).then(() => {
          ElMessage.success({ message: `Password reset link sent to ${requestFormData.emailAddress}`, showClose: true });
          done.value = true;
        });
      } else {
        authStore.resetPassword(resetFormData.emailAddress, resetFormData.passwordResetToken, resetFormData.newPassword).then(() => {
          // TODO: Message below doesnt appear due to redirect, find alternative solution?
          ElMessage.success({ message: "Password reset successful!", showClose: true });
          router.push({ name: "Login" });
        });
      }
    } else {
      handleInvalidForm(fields as ValidateFieldsError);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_unref(code))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(done) ? 'Password reset sent' : 'Request password reset'), 1),
          _createElementVNode("div", _hoisted_5, [
            (!_unref(done))
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  ref_key: "requestFormRef",
                  ref: requestFormRef,
                  model: _unref(requestFormData),
                  rules: requestRules,
                  size: "large",
                  "label-position": "top",
                  "require-asterisk-position": "right"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_form_item, {
                        class: "col-12 pb-2 mb-3 mb-md-4",
                        label: "Email",
                        prop: "emailAddress"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            name: "emailAddress",
                            modelValue: _unref(requestFormData).emailAddress,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(requestFormData).emailAddress) = $event)),
                            placeholder: "Enter your email (*)"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm(requestFormRef.value)))
                        }, "Send link")
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_el_form, {
            ref_key: "resetFormRef",
            ref: resetFormRef,
            class: "col-12 forgot-password-form py-3 py-lg-5",
            model: _unref(resetFormData),
            rules: resetRules,
            size: "large",
            "label-position": "top",
            "require-asterisk-position": "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_form_item, {
                  class: "col-12 pb-2 mb-3 mb-md-4",
                  label: "Email",
                  prop: "emailAddress"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      name: "emailAddress",
                      modelValue: _unref(resetFormData).emailAddress,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(resetFormData).emailAddress) = $event)),
                      placeholder: "Enter your email (*)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "col-12 pb-2 mb-3 mb-md-4",
                  label: "Password",
                  prop: "newPassword"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(resetFormData).newPassword,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(resetFormData).newPassword) = $event)),
                      autocomplete: "new-password",
                      name: "newPassword",
                      type: "password",
                      placeholder: "Enter your password (*)",
                      "show-password": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "col-12 pb-2 mb-3 mb-md-4",
                  label: "Confirm Password",
                  prop: "confirmPassword"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(resetFormData).confirmPassword,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(resetFormData).confirmPassword) = $event)),
                      autocomplete: "new-password",
                      name: "confirmPassword",
                      type: "password",
                      placeholder: "Confirm your password (*)",
                      "show-password": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm(resetFormRef.value)))
                  }, "Reset Password")
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]))
  ]))
}
}

})